// ./src/components/features/Notes/NotesFilterBar/NotesFilterBar.tsx
//
// Filter controls for the event Notes list: by tags (from the account catalog).
// Fully controlled — the page owns the value and maps it to a NoteFilter.
// Title/message search lives in the page header, not here. Requires a
// <TagsProvider> ancestor (the page provides one).

import React from "react";
import { Group, Box } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TagsSelectorInput } from "@/components/generic";

export interface NotesFilterValue {
  tagIds: string[];
}

export interface NotesFilterBarProps {
  value: NotesFilterValue;
  onChange: (value: NotesFilterValue) => void;
  disabled?: boolean;
}

export const EMPTY_NOTES_FILTER: NotesFilterValue = {
  tagIds: [],
};

export const notesFilterActiveCount = (value: NotesFilterValue): number => (value.tagIds.length > 0 ? 1 : 0);

const TAGS_STYLE: React.CSSProperties = { flex: "1 1 320px", minWidth: 260 };

const NotesFilterBarComponent: React.FC<NotesFilterBarProps> = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation(["events"]);

  return (
    <Group gap="sm" align="flex-end" wrap="wrap">
      <Box style={TAGS_STYLE}>
        <TagsSelectorInput
          label={t("events:notes.filters.tags.label", { defaultValue: "Filter by tags" })}
          placeholder={t("events:notes.filters.tags.placeholder", { defaultValue: "Any tag" })}
          value={value.tagIds}
          onChange={(_name, tagIds) => onChange({ ...value, tagIds })}
          maxTags={20}
          allowCreate={false}
          disabled={disabled}
          size="md"
        />
      </Box>
    </Group>
  );
};

export const NotesFilterBar = React.memo(NotesFilterBarComponent);
